import React, { useCallback } from 'react';
import Alert from '@mui/material/Alert';

import { useAppSelector } from '@/state/store';
import { common } from '@/actions';

const hiders: Map<number, number> = new Map();

type MessagesProps = {
  autoHideTimeout?: number
};

export default function ({ autoHideTimeout } : MessagesProps) {
  const messages = useAppSelector((state) => state.common.messages);

  const hideError = useCallback((i: number) => {
    common.hideMessage(i);
    if (hiders.has(i)) {
      clearTimeout(hiders.get(i));
      hiders.delete(i);
    }
  }, []);

  return (<>
      { messages.map(({ type, text }, i) => {
        if (!hiders.has(i)) {
          hiders.set(i, window.setTimeout(() => { hideError(i); }, autoHideTimeout || 10000));
        }
        return (<Alert
            key={i}
            sx={{ position: 'fixed', bottom: 20 + i * 55, left: 20 }}
            severity={type}
            onClose={() => {
              hideError(i);
            }}
          >
            {text}
          </Alert>);
      }) }
    </>
  );
};
